import request from '@utils/fetch'

export function getGardenTextBook(data) {
  return request({
    url: '/teachingKindergartenPrice/getKindergartenPricePageList',
    method: 'post',
    data

  })
}
// 新增院所教材
export function addTextBookByGarden(data) {
  return request({
    url: '/teachingKindergartenPrice/addKindergartenPrice',
    method: 'post',
    data
  })
}

export function deleteTextBookByGarden(data) {
  return request({
    url: '/teachingKindergartenPrice/delKindergartenPrice',
    method: 'delete',
    params: data
  })
}
// 修改院所教材
export function editTextBookByGarden(data) {
  return request({
    url: '/teachingKindergartenPrice/updateKindergartenPrice',
    method: 'post',
    data
  })
}
